import { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';
import { StringKey } from '../../../lang/index';
import { EventTypeBackend } from '../../../types/events.types';

export type DeleteEventModalProps = {
  hasSignatures?: boolean;
  onClose: () => void;
  onSuccess: () => void;
  type: EventTypeBackend;
};

const deleteDescription: PartialRecord<EventTypeBackend, StringKey> = {
  [EventTypeBackend.SAFE_CONVERSION]: 'SAFE_CONVERSION_DELETE_CONFIRMATION',
  [EventTypeBackend.COMPANY_INCORPORATION]: 'COMPANY_INCORPORATION_DELETE_CONFIRMATION',
};

const getDeleteDescription = (type: EventTypeBackend, hasSignatures?: boolean): StringKey => {
  if (type === EventTypeBackend.GRANT) {
    return hasSignatures
      ? 'GRANT_DELETE_CONFIRMATION_WITH_SIGNATURE'
      : 'GRANT_DELETE_CONFIRMATION_WITHOUT_SIGNATURE';
  }
  return deleteDescription[type] || 'DELETE_PLAN_WARNING';
};

export const DeleteEventModal: FC<DeleteEventModalProps> = ({
  hasSignatures,
  onClose,
  onSuccess,
  type,
}) => {
  const isCompanyIncorporation = type === EventTypeBackend.COMPANY_INCORPORATION;

  return (
    <div className="m-2 flex w-full min-w-[300px] flex-col gap-8 rounded bg-white p-4 xlg:w-[453px]">
      <div className="flex flex-col gap-1">
        <span className="text-xl font-[550] text-gray-700">
          <AppFormattedMessage id="DELETE_EVENT" />?
        </span>
        <span className="whitespace-pre-line text-xs font-[450] text-gray-500">
          <AppFormattedMessage
            id={getDeleteDescription(type, hasSignatures)}
            values={{
              text: <AppFormattedMessage id="EVENT" />,
            }}
          />
        </span>
      </div>
      <div className="flex h-11 justify-end gap-4">
        <Button
          className="h-full w-fit rounded border border-gray-300 px-6 py-[10px] text-sm font-[450] text-gray-700"
          onClick={onClose}
          styleType="NONE"
        >
          <AppFormattedMessage id={isCompanyIncorporation ? 'CANCEL' : 'NO_KEEP_3'} />
        </Button>
        <Button
          className="h-full w-fit bg-fireside-600 px-6 py-[10px] text-sm font-[550] text-white"
          data-permission-required
          onClick={onSuccess}
          styleType="NONE"
        >
          <AppFormattedMessage id="CONFIRM_DELETE" />
        </Button>
      </div>
    </div>
  );
};
